import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_CAT_CODES = graphql(`
  query getCatCodes {
    catCodes(pagination: { first: 500 }) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`);

export function useCatCodesQuery() {
  const { loading, data, error, refetch } = useQuery(GET_CAT_CODES);

  return {
    loading,
    error,
    data,
    refetch,
  };
}
